export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7526.143b91bc.jpg";